import type { AssetType } from "@overmap-ai/common"
import type { ExpressionSpecification } from "mapbox-gl"

import { MAPBOX_DEFUALT_ICON_SIZE } from "../constants"

export function getAssetTypeLayerIds(assetTypeId: AssetType["uuid"]) {
	return {
		// Symbol
		assetSymbolLayerId: `${assetTypeId}-symbol`,
		assetSymbolBackgroundLayerId: `${assetTypeId}-symbol-background`,

		// Circle
		assetCircleLayerId: `${assetTypeId}-circle`, // this is the representative layer

		// Line
		assetLineLayerId: `${assetTypeId}-line`, // this is the representative layer
		assetOuterLineLayerId: `${assetTypeId}-outer-line`,

		// Fill
		assetFillLayerId: `${assetTypeId}-fill`, // this is the representative layer
		assetFillLineLayerId: `${assetTypeId}-fill-line`,
	} as const
}

export function getCircleLayerSizes(icons: boolean): {
	symbolIconSize: ExpressionSpecification
	symbolRadius: ExpressionSpecification
	circleRadius: ExpressionSpecification
	circleStroke: ExpressionSpecification
	selectedRadius: ExpressionSpecification
} {
	const baseSize = 32
	const scale = 1.25

	const baseFactor = icons ? 1 : 2 / 3
	const symbolIconFactor = (5 / 6 / MAPBOX_DEFUALT_ICON_SIZE) * baseFactor
	const symbolRadiusFactor = (2 / 3) * baseFactor
	const circleRadiusFactor = baseFactor
	const circleStrokeFactor = (1 / 3) * baseFactor
	const selectedRadiusFactor = (4 / 3) * baseFactor

	const breakpoints = [10, 14, 16, 18, 20, 22, 24] as const

	const getBreakpointSteps = (factor: number) => {
		return breakpoints.flatMap((breakpoint) => [
			breakpoint,
			["*", baseSize * factor, ["^", scale, ["-", ["zoom"], 24]]],
		])
	}

	return {
		symbolIconSize: ["interpolate", ["exponential", scale], ["zoom"], ...getBreakpointSteps(symbolIconFactor)],
		symbolRadius: ["interpolate", ["exponential", scale], ["zoom"], ...getBreakpointSteps(symbolRadiusFactor)],
		circleRadius: ["interpolate", ["exponential", scale], ["zoom"], ...getBreakpointSteps(circleRadiusFactor)],
		circleStroke: ["interpolate", ["exponential", scale], ["zoom"], ...getBreakpointSteps(circleStrokeFactor)],
		selectedRadius: ["interpolate", ["exponential", scale], ["zoom"], ...getBreakpointSteps(selectedRadiusFactor)],
	}
}
